<rk-platform-publishing-shell class="relative">
  <div
    class="flex gap-2 mb-8 items-center"
    [class.blur-[1px]]="noIosPublishingData$ | async"
    [class.opacity-30]="noIosPublishingData$ | async"
  >
    <fa-icon class="opacity-50 text-2xl" [icon]="['fab', 'apple']"></fa-icon>
    <span class="text-xl font-bold">iOS</span>
  </div>

  <div class="publishing-steps overflow-auto relative">
    @if (noIosPublishingData$ | async) {
      <rk-ios-publishing-empty-state></rk-ios-publishing-empty-state>
    }
    @if (appStoreLink$ | async) {
      <rk-ios-screenshot></rk-ios-screenshot>
    } @else {
      @if (iosPublishingData$ | async; as iosData) {
        @for (step of iosData.steps; track step.name) {
          <rk-publishing-step
            [stepType]="step.name"
            [status]="step.status"
            platform="ios"
            [ctaLink]="step.url"
          >
          </rk-publishing-step>
        }
      }
    }
  </div>
</rk-platform-publishing-shell>
